const layerIndexes = layers => new Map(layers.reduce(
  (m, layer, index) => {
    m.push([ layer.id, index ])
    return m
  },
  []
))

export default layerIndexes
